"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReshapedNormalizer = getReshapedNormalizer;
exports["default"] = void 0;

function getReshapedNormalizer(normalizer) {
  var reshapedNormalizer = {};
  Object.keys(normalizer).forEach(function (datumKey) {
    var stateKeyOrObj = normalizer[datumKey];
    reshapedNormalizer[datumKey] = {};

    if (typeof stateKeyOrObj !== 'string') {
      reshapedNormalizer[datumKey].tag = stateKeyOrObj.tag;
      reshapedNormalizer[datumKey].apiPath = stateKeyOrObj.apiPath;
      reshapedNormalizer[datumKey].isMergingArray = stateKeyOrObj.isMergingArray;
      reshapedNormalizer[datumKey].isMutatingDatum = stateKeyOrObj.isMutatingDatum;
      reshapedNormalizer[datumKey].isMergingDatum = stateKeyOrObj.isMergingDatum;
      reshapedNormalizer[datumKey].isMutatingDatum = stateKeyOrObj.isMutatingDatum;
      reshapedNormalizer[datumKey].method = stateKeyOrObj.method;
      reshapedNormalizer[datumKey].normalizer = stateKeyOrObj.normalizer;
      reshapedNormalizer[datumKey].process = stateKeyOrObj.process;
      reshapedNormalizer[datumKey].resolve = stateKeyOrObj.resolve;
      reshapedNormalizer[datumKey].stateKey = stateKeyOrObj.stateKey ? stateKeyOrObj.stateKey : datumKey;
    } else {
      reshapedNormalizer[datumKey].stateKey = stateKeyOrObj;
    }
  });
  return reshapedNormalizer;
}

var _default = getReshapedNormalizer;
exports["default"] = _default;